import { Fragment, type ReactNode } from "react";

/** Render copy with two inline markers: **bold** -> <strong>, ##x## -> <span class="num">.
 * Copy is hardcoded/trusted, but we still avoid dangerouslySetInnerHTML. */
export function renderRich(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*|##[^#]+##)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <strong key={i}>{p.slice(2, -2)}</strong>;
    if (p.startsWith("##") && p.endsWith("##")) return <span className="num" key={i}>{p.slice(2, -2)}</span>;
    return <Fragment key={i}>{p}</Fragment>;
  });
}
